export default __webpack_public_path__ + "assets/images/b40336aaa3ca86d48b75fb457db69d21.svg";